// German translations - single language active, i18n architecture ready for EN/AR
export const de = {
  brand: {
    name: "Handy Meister",
    tagline: "Smartphone-Reparatur",
  },
  nav: {
    home: "Startseite",
    repair: "Reparatur",
    prices: "Preise",
    appointment: "Termin buchen",
    status: "Reparaturstatus",
    shipping: "Versand-Reparatur",
    locations: "Standorte",
    about: "Über uns",
    faq: "FAQ",
    contact: "Kontakt",
    admin: "Admin",
  },
  cta: {
    startRepair: "Reparatur starten",
    bookAppointment: "Termin buchen",
    viewPrices: "Preise ansehen",
    whatsapp: "Per WhatsApp anfragen",
    selectDevice: "Gerät auswählen",
    showModels: "Modelle anzeigen",
    showRepairs: "Reparaturen anzeigen",
    select: "Auswählen",
    next: "Weiter",
    back: "Zurück",
    submit: "Absenden",
    save: "Speichern",
    startOver: "Neu starten",
    sendRequest: "Reparaturanfrage senden",
    startShipping: "Versand-Reparatur starten",
    savePdf: "Auswahl als PDF speichern",
  },
  hero: {
    title: "Professionelle Smartphone-Reparatur.",
    subtitle: "Schnell, transparent und zuverlässig.",
    description:
      "Wählen Sie Ihr Smartphone und den gewünschten Reparaturservice aus. Sie sehen sofort den voraussichtlichen Preis und können direkt einen Termin buchen oder eine Reparaturanfrage senden.",
  },
  trust: {
    prices: "Transparente Preise",
    fast: "Schnelle Reparatur",
    quality: "Hochwertige Ersatzteile",
    warranty: "Reparaturgarantie",
    data: "Sichere Datenbehandlung",
  },
  configurator: {
    step1: "Marke",
    step2: "Modell",
    step3: "Reparatur",
    step4: "Qualität",
    step5: "Übersicht",
    step6: "Termin oder Anfrage",
    selectBrand: "Marke auswählen",
    selectModel: "Modell auswählen",
    selectRepair: "Reparatur auswählen",
    selectQuality: "Qualität auswählen",
    summary: "Reparaturübersicht",
    searchBrand: "Marke suchen",
    searchModel: "Smartphone-Modell suchen",
    modelNotListed: "Mein Modell ist nicht aufgeführt",
    supportedModels: "unterstützte Modelle",
    startingFrom: "ab",
    duration: "Dauer",
    warranty: "Garantie",
    warrantyMonths: "Monate Garantie",
    minutes: "Min.",
    total: "Geschätzter Gesamtpreis",
    subtotal: "Zwischensumme",
    comboDiscount: "Kombinationsrabatt",
    estimatedDuration: "Geschätzte Reparaturzeit",
    yourDevice: "Ihr Gerät",
    selectedRepairs: "Ausgewählte Reparaturen",
    noRepairs: "Bitte wählen Sie mindestens eine Reparatur aus.",
    changeModel: "Modell ändern",
    addRepair: "Weitere Reparatur",
    remove: "Entfernen",
    change: "Ändern",
    popularBrands: "Beliebte Marken",
    allBrands: "Alle Marken",
    apple: "Apple",
    android: "Android",
  },
  common: {
    loading: "Wird geladen…",
    empty: "Keine Einträge vorhanden.",
    error: "Ein Fehler ist aufgetreten.",
    required: "Pflichtfeld",
    yes: "Ja",
    no: "Nein",
    optional: "optional",
    from: "ab",
    from_price: "Ab",
    fixed_price: "Festpreis",
    price_on_request: "Preis auf Anfrage",
    price_after_diagnosis: "Preis nach Diagnose",
  },
  footer: {
    tagline: "Ihr professioneller Partner für Smartphone-Reparaturen in Deutschland.",
    quickLinks: "Schnellnavigation",
    popularRepairs: "Beliebte Reparaturen",
    legal: "Rechtliches",
    contact: "Kontakt",
    hours: "Öffnungszeiten",
    payment: "Zahlungsarten",
    copyright: "© 2026 Handy Meister. Alle Rechte vorbehalten.",
  },
  cookie: {
    title: "Diese Website verwendet Cookies",
    text:
      "Wir verwenden notwendige Cookies für den Betrieb der Website. Optionale Cookies helfen uns, das Angebot zu verbessern. Sie können Ihre Auswahl jederzeit ändern.",
    acceptAll: "Alle akzeptieren",
    onlyEssential: "Nur notwendige",
    settings: "Einstellungen",
    necessary: "Notwendig",
    statistics: "Statistik",
    marketing: "Marketing",
    external: "Externe Medien",
    save: "Auswahl speichern",
  },
  scarcity: {
    low_stock: "Nur noch wenige verfügbar",
    out_of_stock: "Aktuell nicht auf Lager — bitte anfragen",
    in_stock: "Auf Lager",
  },
};

export const t = (path) => {
  const parts = path.split(".");
  let cur = de;
  for (const p of parts) {
    if (cur && typeof cur === "object" && p in cur) cur = cur[p];
    else return path;
  }
  return cur;
};
